import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { PortalShell } from "@/components/portal/PortalShell";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const NAV = [
  { to: "/app/crm", label: "Übersicht" },
  { to: "/app/crm/customers", label: "Kunden" },
  { to: "/app/crm/leads", label: "Leads" },
  { to: "/app/crm/projects", label: "Projekte" },
];

export const Route = createFileRoute("/_authenticated/app/crm/")({
  ssr: false,
  head: () => ({ meta: [{ title: "CRM" }, { name: "robots", content: "noindex,nofollow" }] }),
  component: CrmDashboard,
});

function CrmDashboard() {
  const { data } = useQuery({
    queryKey: ["crm-counts"],
    queryFn: async () => {
      const [c, l, p] = await Promise.all([
        supabase.from("customers").select("id", { count: "exact", head: true }),
        supabase.from("leads").select("id", { count: "exact", head: true }),
        supabase.from("projects").select("id", { count: "exact", head: true }),
      ]);
      return { customers: c.count ?? 0, leads: l.count ?? 0, projects: p.count ?? 0 };
    },
  });

  const tiles = [
    { label: "Kunden", value: data?.customers ?? "…", to: "/app/crm/customers" },
    { label: "Leads", value: data?.leads ?? "…", to: "/app/crm/leads" },
    { label: "Projekte", value: data?.projects ?? "…", to: "/app/crm/projects" },
  ];

  return (
    <PortalShell nav={NAV}>
      <h1 className="text-2xl font-semibold mb-6">CRM-Übersicht</h1>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {tiles.map((t) => (
          <Link key={t.to} to={t.to}>
            <Card className="hover:bg-accent/30 transition-colors">
              <CardHeader><CardTitle className="text-sm text-muted-foreground">{t.label}</CardTitle></CardHeader>
              <CardContent><div className="text-3xl font-bold">{t.value}</div></CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </PortalShell>
  );
}